import type { DiscoveryGetTrendsCategory } from './discoveryGetTrendsCategory';

export type DiscoveryGetTrendsParams = {
/**
 * 카테고리
 */
category?: DiscoveryGetTrendsCategory;
};
